<!-- Inicio javascript do seletor de quantidade -->
$(document).ready(function() {
  var $buttonPlus = $('.qtyplus');
  var $buttonMin = $('.qtyminus');
  var $quantity = $('.qty');
  
  /*For plus and minus buttons*/
  $buttonPlus.click(function() {
    $quantity.val(parseInt($quantity.val()) + 1).trigger('input');
  });
  
  $buttonMin.click(function() {
    $quantity.val(Math.max(parseInt($quantity.val()) - 1, 0)).trigger('input');
  });
})
<!-- Final javascript do seletor de quantidade -->

if (window.matchMedia("(max-width: 768px)").matches) {
  window.addEventListener('scroll', function() {
    var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
        btn = document.getElementById('scrollToTop');
    if (btn) {
      if (pageOffset > 1200) {
        btn.style.display = 'block';
      } else {
        btn.style.display = 'none';
      }
      // Esconde o botão ao voltar ao topo
      if (pageOffset < 1) {
        btn.style.display = 'none';
      }
    }
  });
  // Oculta o botão no carregamento inicial
  var btn = document.getElementById('scrollToTop');
  if (btn) btn.style.display = 'none';
}

   // Script personalizar
  $(".block-swatch__radio:checked").each(function(i){$(this).val()=="Sim Quero Personalizar"?$(".personalizacao").show():$(this).val()=="N\xE3o"&&$(".personalizacao").hide()}),$(".block-swatch__radio").click(function(){$(this).val()==="Sim Quero Personalizar"?$(".personalizacao").show():$(this).val()==="N\xE3o"&&$(".personalizacao").hide()});


